export enum NotificationTypes {
    NewEmail = 'NewEmail',
    EventReminder = 'EventReminder',
}
